/**
 * useGenerationScreeningAdmissions — the workbench's live envelope-availability
 * hook. Fetches the `equipment_catalog` screening rows once per mount and runs
 * them through the pure admissions gate.
 *
 * FIRST RENDER = the full shipped static catalog ('static' authority), so the
 * page is byte-identical to the pre-Firestore behavior until (and unless) the
 * fetch admits a governed subset. Fetch failure / unseeded project stays on
 * the static fallback permanently — nothing blocks on the network.
 */
import { useEffect, useState } from 'react';
import {
  admitGenerationScreeningEntries,
  type ScreeningAdmissionResult,
} from '../../../lib/generationImpact/generationEquipmentCatalogAdmissions';
import { fetchGenerationScreeningDocs } from '../../../services/supplyChain/equipmentCatalogStore';

const STATIC_RESULT: ScreeningAdmissionResult = admitGenerationScreeningEntries([]);

export function useGenerationScreeningAdmissions(): ScreeningAdmissionResult {
  const [result, setResult] = useState<ScreeningAdmissionResult>(STATIC_RESULT);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const docs = await fetchGenerationScreeningDocs();
      if (cancelled || docs.length === 0) return;
      setResult(admitGenerationScreeningEntries(docs));
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return result;
}
